import * as t from '../actionTypes'
import axios from 'utils/axios'
import { guardFromErrors, extractErrorInfo } from 'utils/graphqlHelpers'
import { DTGSize } from '../types'

export type FetchDTGSizesForOptionsAction = FSA<undefined, DTGSize[], string>
type FetchDTGSizesForOptions = (searchText?: string) => MrxThunk<FetchDTGSizesForOptionsAction>
type QueryResponse = GraphQLResponse<'DTGSizesForOptions', DTGSize[]>

const FETCH_DTG_SIZE_FOR_OPTIONS = `
  query DTGSizesForOptions($searchText: String) {
    DTGSizesForOptions(searchText: $searchText) {
      id
      name
    }
  }
`

const fetchDTGSizesForOptions: FetchDTGSizesForOptions = searchText => async (dispatch) => {
  dispatch({
    type: t.FETCH_DTG_SIZE_FOR_OPTIONS,
    meta: { done: false }
  })

  try {
    const {
      data: { data, errors }
    }: QueryResponse = await axios.post('/graphql', {
      query: FETCH_DTG_SIZE_FOR_OPTIONS,
      variables: { searchText }
    })

    guardFromErrors(errors)

    if (!data) {
      throw new Error('Response body is empty!')
    }

    const { DTGSizesForOptions } = data
    if (!DTGSizesForOptions) {
      throw new Error("Can't get DTGSizes!")
    }

    dispatch({
      type: t.FETCH_DTG_SIZE_FOR_OPTIONS,
      payload: DTGSizesForOptions,
      meta: { done: true }
    })
  } catch (err) {
    dispatch({
      type: t.FETCH_DTG_SIZE_FOR_OPTIONS,
      payload: extractErrorInfo(err),
      error: true
    })
  }
}

export { fetchDTGSizesForOptions }
